/** @format */

import { useState } from "react";
import RightMenu from "../Sidebar/right-menu";
import TopNav from "../Navbar/top-nav";
// import "./index.scss";
import { useDispatch, useSelector } from "react-redux";
import { toggelSideMenu } from "../../store/stateSlice";
import { Navigate } from "react-router-dom";
export default function NavbarAndSidebar(props) {
  const { isMenuOpen } = useSelector((state) => state.toggleState.value);
  let dispatch = useDispatch();
  const toggleMenu = () => {
    dispatch(toggelSideMenu());
  };

  return (
    <>
      {localStorage.getItem("jwt") ? (
        <>
          {" "}
          <RightMenu isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} />{" "}
          <TopNav isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} />
          <div className={`body-cont ${isMenuOpen && "body-cont--add-margin"}`}>
            {props.children}
          </div>{" "}
        </>
      ) : (
        <Navigate to='/login' />
      )}
    </>
  );
}
